<template>
  <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
    <ul>
      <li><router-link to="/" exact>Home</router-link></li>
      <template v-for="(item, idx) in crumbs">
        <li v-if="item.active" :key="`crumbs-${idx}`" class="is-active">
          <a disabled aria-current="page">{{ item.title }}</a>
        </li>
        <li v-else :key="`crumbs-${idx}`">
          <router-link :to="item.to" exact>{{ item.title }}</router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'Breadcrumbs',
  props: {
    crumbs: { type: Array, default: () => [] },
  },
};
</script>
